import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { MaintenanceResponseModel } from '@shared/models/maintenance.model';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private readonly http = inject(HttpClient);

  private readonly maintenanceModeEnabled$: Observable<boolean> = environment.maintenanceUrl
    ? this.http.get<MaintenanceResponseModel>(environment.maintenanceUrl).pipe(
        map((data) => data?.maintenanceModeEnabled === true),
        catchError(() => of(false)),
        shareReplay(1),
      )
    : of(false);

  isMaintenanceModeEnabled(): Observable<boolean> {
    return this.maintenanceModeEnabled$;
  }
}
